/*
  WhackSports cart drawer UI (theme replacement for ConvertCart cart campaign).
  Ported from ConvertCart experiment CSS/JS. Does not replace cart add/update/checkout.
  Owner: ConvertCart cart drawer experiment (nativized).
  Orders Delivered count is Liquid-only from shop.metafields.custom.total_orders — do not overwrite via JS.
*/
(function () {
  const REVIEW_API = 'https://us-central1-ccart-prod.cloudfunctions.net/custom-whacksports';
  const SAVE_ICON = 'https://cdn.convertcart.com/uploads/d329b655.webp';
  const LOCK_ICON = 'https://cdn.convertcart.com/uploads/169b8d79.webp';

  let form = null;
  let reviewsLoaded = false;
  let lastSubtotalText = '';
  let lastSavingsKey = '';
  let observer = null;
  let updating = false;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatSoldCount(n) {
    try {
      return Number(n).toLocaleString();
    } catch (e) {
      return String(n);
    }
  }

  function formatSavings(amount) {
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      })
        .format(amount)
        .replace('A$', '$');
    } catch (e) {
      return '$' + amount;
    }
  }

  function appendNavidiumIcon() {
    if (!form) return;
    const label = qs('.drawer__footer .nvd-mini .appearance-right-previw-ld .flex-grow-1Cstm-ld > p', form);
    if (!label || qs('.cc-click-hover-icon', label)) return;
    const icon = document.createElement('div');
    icon.className = 'cc-click-hover-icon';
    label.appendChild(icon);
  }

  function isAuNzShipping() {
    const country =
      document.body.getAttribute('data-country') || document.documentElement.getAttribute('data-country') || '';
    if (country === 'AU' || country === 'NZ') return true;
    const inner = form ? qs('.drawer__inner', form) : null;
    return !!(inner && inner.classList.contains('free_shipping_cart'));
  }

  function syncShippingBars() {
    if (!form) return;
    const auNz = isAuNzShipping();
    const inner = qs('.drawer__inner', form);
    if (inner) {
      inner.classList.toggle('free_shipping_cart', auNz);
      inner.classList.toggle('other_shipping_class', !auNz);
    }
    const keepClass = auNz ? 'free_shipping_cart_class' : 'other_shipping_cart_class';
    let shown = 0;
    qsa('.ct-prograss-bar-main', form).forEach(function (el) {
      const keep = el.classList.contains(keepClass) && shown === 0;
      el.style.setProperty('display', keep ? 'block' : 'none', 'important');
      if (keep) shown += 1;
    });
  }

  function highlightRemainingAmount() {
    if (!form) return;
    const title =
      qs('.free_shipping_cart .ct-prograss-bar-main.free_shipping_cart_class .ct-cart-drawer-title', form) ||
      qs('.other_shipping_class .ct-prograss-bar-main.other_shipping_cart_class .ct-cart-drawer-title', form) ||
      qs('.ct-prograss-bar-main.other_shipping_cart_class .ct-cart-drawer-title', form);
    if (!title || qs('.cc-remain-amount', title)) return;
    const text = (title.textContent || '').trim();
    const next = text.replace(/([^\d\s]+\s*\d+[.,]?\d*\s*away)/i, '<span class="cc-remain-amount">$1</span>');
    if (next !== text) title.innerHTML = next;
  }

  function applyReviewStats(locations) {
    if (!Array.isArray(locations) || !locations.length) return;
    let total = 0;
    locations.forEach(function (item) {
      total += item.reviewCount || 0;
    });
    if (!total) return;
    qsa('.cc-review-count', form).forEach(function (el) {
      el.textContent = formatSoldCount(total);
    });
    reviewsLoaded = true;
  }

  function loadReviewCount() {
    if (reviewsLoaded || !form) return;
    if (!qs('.cart__checkout-wrapper .ws-cart-reviews', form)) return;

    if (window.wsTrustStripStats) {
      applyReviewStats(window.wsTrustStripStats);
      return;
    }

    fetch(REVIEW_API)
      .then(function (res) {
        if (!res.ok) throw new Error('review fetch failed');
        return res.json();
      })
      .then(function (data) {
        const list = data && data.apiResponse;
        if (!Array.isArray(list) || !list.length) return;
        window.wsTrustStripStats = list;
        applyReviewStats(list);
      })
      .catch(function () {});
  }

  function readLiquidSavings() {
    const items = qs('.cart__items', form);
    if (!items || !items.getAttribute('data-ws-compare-savings')) return null;
    const n = parseInt(items.getAttribute('data-ws-compare-savings'), 10);
    return isNaN(n) ? 0 : n;
  }

  function savingsFromDataLayer() {
    if (!window.dataLayer || !window.dataLayer.filter) return null;
    const entry = window.dataLayer.filter(function (d) {
      return d && d[1] === 'miniCartViewed';
    }).pop();
    const miniCartData = entry ? entry[2] : null;
    if (!miniCartData || !miniCartData.items) return null;
    return miniCartData;
  }

  function applySavingsBanner(totalSavings) {
    const btn = qs('.btn.cart__checkout.CT_cart__checkout', form);
    if (!btn) return;

    const old = qs('.cc-save-text', form);
    if (!totalSavings) {
      if (old) old.remove();
      lastSavingsKey = '0';
      return;
    }

    const formatted = formatSavings(totalSavings);
    const key = String(totalSavings);
    if (old && lastSavingsKey === key) return;

    if (old) old.remove();
    btn.classList.add('ccSaveValue4264');
    btn.insertAdjacentHTML(
      'beforebegin',
      '<span class="save-text cc-save-text">' +
        '<img src="' +
        SAVE_ICON +
        '" alt="" width="15" height="15" />' +
        'You saved ' +
        formatted +
        ' today!</span>'
    );

    if (!qs('img[alt="checkout"]', btn)) {
      btn.textContent = 'secure checkout';
      btn.insertAdjacentHTML(
        'beforeend',
        '<img src="' + LOCK_ICON + '" alt="checkout" width="17" height="17" />'
      );
    }
    lastSavingsKey = key;
  }

  function updateSavings() {
    if (!form) return;
    const liquidValue = readLiquidSavings();
    if (liquidValue !== null) {
      applySavingsBanner(liquidValue);
      return;
    }

    const miniCartData = savingsFromDataLayer();
    if (!miniCartData) return;
    const items = miniCartData.items;
    const requests = items.map(function (item) {
      const url = item.url.split('?')[0] + '.json';
      return fetch(url)
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          const product = data.product;
          if (!product || !product.variants) return 0;
          const variant = product.variants.filter(function (v) {
            return String(v.id) === String(item.child_id);
          })[0];
          if (!variant) return 0;
          const input = qs('input[data-id^="' + item.child_id + '"]', form);
          const qty = input ? parseInt(input.value, 10) || 0 : item.quantity;
          const price = parseFloat(variant.price) || 0;
          const compare = parseFloat(variant.compare_at_price) || 0;
          return compare > price ? (compare - price) * qty : 0;
        })
        .catch(function () {
          return 0;
        });
    });

    Promise.all(requests).then(function (results) {
      const totalSavings = Math.round(
        results.reduce(function (sum, val) {
          return sum + val;
        }, 0)
      );
      applySavingsBanner(totalSavings);
    });
  }

  function onCartUiChange() {
    if (!form || updating) return;
    updating = true;
    if (observer) observer.disconnect();
    syncShippingBars();
    highlightRemainingAmount();
    appendNavidiumIcon();
    updateSavings();
    if (observer) observer.observe(form, { childList: true, subtree: true });
    updating = false;
  }

  function bindObserver() {
    if (observer || !form) return;
    observer = new MutationObserver(function () {
      const sub = qs('.ajaxcart__subtotal_price', form);
      const text = sub ? sub.textContent : '';
      if (text !== lastSubtotalText) {
        lastSubtotalText = text;
        lastSavingsKey = '';
      }
      onCartUiChange();
    });
    observer.observe(form, { childList: true, subtree: true });
  }

  function boot() {
    form = document.getElementById('CartDrawerForm');
    if (!form) return;

    const sub = qs('.ajaxcart__subtotal_price', form);
    lastSubtotalText = sub ? sub.textContent : '';

    onCartUiChange();
    bindObserver();
    loadReviewCount();

    document.addEventListener('cart:updated', onCartUiChange);
    document.addEventListener('ajaxProduct:added', onCartUiChange);
    document.addEventListener('ws:geo-ready', onCartUiChange);
    document.addEventListener('drawerOpen.CartDrawer', function () {
      onCartUiChange();
      loadReviewCount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
